// extracted by mini-css-extract-plugin
export default {"ThumbVertical":"Scrollbar_ThumbVertical__GKrQo","ThumbHorizontal":"Scrollbar_ThumbHorizontal__Rwe0l"};